
/* eslint-disable vue/no-reserved-component-names,vue/multi-word-component-names */
import { H1, H2, H3, H4, H5, H6 } from './style'
import VueTypes from 'vue-types'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Heading',
  props: {
    as: VueTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).def('h1'),
    className: VueTypes.string,
    id: VueTypes.string,
    styles: VueTypes.object.def({})
  },
  components: {
    H1,
    H2,
    H3,
    H4,
    H5,
    H6
  }
})
